import React from 'react';

export const TV = ({ height="64px", width="93px",padding="12px", style=''})=> (
    <svg  role='presentation' aria-label='' width={width} height={height} padding={padding} viewBox="0 0 93 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <path id="a" d="M1.968 0C1.368 0 .881.474.881 1.058v56.5c0 .585.487 1.058 1.087 1.058h89.076c.6 0 1.086-.473 1.086-1.057V1.058C92.13.474 91.644 0 91.044 0H1.968z"/>
            <path id="c" d="M1.968 0C1.368 0 .881.474.881 1.058v56.5c0 .585.487 1.058 1.087 1.058h75.506L17.203 0H1.967z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <path fill="#85949B" d="M15.336 58.023l-4.79 5.91h6.342l4.79-5.91zM70.627 58.023l4.79 5.91h6.341l-4.79-5.91z"/>
            <mask id="b" fill="#fff">
                <use xlinkHref="#a"/>
            </mask>
            <path fill="#9FB7C1" d="M1.968 0C1.368 0 .881.474.881 1.058v56.5c0 .585.487 1.058 1.087 1.058h89.076c.6 0 1.086-.473 1.086-1.057V1.058C92.13.474 91.644 0 91.044 0H1.968z" mask="url(#b)"/>
            <path fill="#32A0DA" d="M5.414 54.208H87.6v-49.8H5.414z" mask="url(#b)"/>
            <mask id="d" fill="#fff">
                <use xlinkHref="#c"/>
            </mask>
            <path fill="#96A7AF" d="M1.968 0C1.368 0 .881.474.881 1.058v56.5c0 .585.487 1.058 1.087 1.058h75.506L17.203 0H1.967z" mask="url(#d)"/>
            <path fill="#9FB7C1" d="M21.736 4.408H5.413V54.21H72.94z" mask="url(#d)"/>
            <path fill="#2990C7" d="M21.736 4.408H5.413V54.21H72.94z" mask="url(#d)"/>
            <path stroke="#CAD9E0" stroke-linecap="round" stroke-width=".75" d="M-14 63.75h119.531" mask="url(#d)"/>
        </g>
    </svg>
);
